import styled, { css } from "styled-components";

import { Palette } from "../../../../core/styles/theme";

const Styles = css`
    &.aevi-title-login {
        font-family: RobotoLight, sans-serif;
        font-size: 24pt;
        font-weight: 400;
        line-height: 32pt;
        color: ${Palette.AeviBlack};
    }
`;

const TitleLoginStyle = styled.h1`
    ${Styles};
`;

export const TitleLogin = styled(TitleLoginStyle).attrs(() => ({ className: "aevi-title-login" }))``;
